export default __webpack_public_path__ + "static/media/magalies.f475ccd0.png";